<template>
  <div class="container-fluid buy_url learn_more">

    <div class="row top-bar" v-if="institutionMeta">
      <div class="col-12">
        <div class="row header mt-2">
          <div class="col-4"></div>
          <div class="col-4 logo_container" style="text-align: center;">
            <template v-if="otherInstitutionMeta">
              <template v-if="otherInstitutionMeta.logo">
                <img class="logo ace_sec" :src="otherInstitutionMeta.logo" alt="institutionMeta logo">
              </template>
              <template v-else>
                <h3>{{otherInstitutionMeta.title}}</h3>
              </template>
            </template>
            <template v-else>
              <template v-if="institutionMeta.logoUrl">
                <img class="logo ace_sec" :src="logoUrl" alt="institutionMeta logo">
              </template>
              <template v-else>
                <h3>{{institutionMeta.title}}</h3>
              </template>
            </template>
          </div>
          <div class="col-4">
          </div>
        </div>
      </div>
    </div>

    <div class="row pg_content_container">
      <div class="col-12 content-section" v-if="institutionMeta">
        <template v-if="orgId">
          <template v-if="showVerifyEmail">
            <div class="row pg_subhd">
              <div class="col-12">
                <div class="hd_txt">
                  <span>Verify Email</span>
                </div>
                <div class="row hd_msg">
                  <div class="col-xl-7 col-lg-8 col-md-12 col-sm-12 txt_center" style="margin: auto;">
                    A verification code has been sent to your email.
                  </div>
                  <div class="col-xl-7 col-lg-8 col-md-12 col-sm-12 txt_center" style="margin: auto;">
                    You will use your email to log in to our learning platform. Please enter the verification code sent to your email. If you don’t see the email, please check your spam or bulk mail folders.
                  </div>
                </div>
              </div>
            </div>
            <div class="row crd_container">
              <b-card class="col-12 crd">
                <div class="row fld_row">
                  <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 fld_label">
                    Email
                  </div>
                  <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 fld_val">
                    <span>{{eMail}}</span>
                  </div>
                </div>
                <div class="row fld_row">
                  <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 fld_label" id="verificationCode">
                    Verification Code <sup>*</sup>
                  </div>
                  <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 fld_input">
                    <b-form-input type="text" v-model.trim="verificationCode" :state="verificationCodeState"
                      placeholder="Verification Code" @input="$v.verificationCode.$touch()"
                      aria-describedby="verificationCodeFeedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="verificationCodeFeedback">
                      Verification Code is required
                    </b-form-invalid-feedback>
                  </div>
                </div>
                <div class="row fld_row">
                  <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 fld_label">
                  </div>
                  <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 btn_container">
                    <div class="row">
                      <div class="col-12 btn_sec">
                        <b-button size="lg" @click="verifyEmail" aria-label="verify email" :disabled="!verificationCode">verify email</b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
          </template>
          <template v-else>
            <template v-if="isExistingAccount">
              <div class="row pg_subhd">
                <div class="col-12">
                  <div class="hd_txt">
                    <span>Login to {{institutionMeta.title}}</span>
                  </div>
                  <div class="row hd_msg">
                    <div class="col-xl-7 col-lg-8 col-md-12 col-sm-12 txt_center" style="margin: auto;">
                      Please login with your existing account to check the details of {{programGuide.title}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-7 col-lg-8 col-md-12" style="margin: auto; padding-top: 10px; height: 20px;">
                      <div class="w-100" id="validation-message" style="color: #ff0000; text-align: center;  display: none;" v-html="errorMessage"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div @keydown.enter="login">
                <div class="row crd_container">
                  <b-card class="col-12 crd price_plan_sec price_plan_sec2">
                    <div class="row fld_row">
                      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 fld_label" id="userEmail">
                        Email <sup>*</sup>
                      </div>
                      <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 fld_input">
                        <b-form-input type="email" v-model.email="eMail" :state="eMailState"
                          aria-labelledby="email" placeholder="Email" @input="forceEmailLowerCase($event)"
                          aria-describedby="eMailFeedback">
                        </b-form-input>
                        <b-form-invalid-feedback id="eMailFeedback">
                          This is not a valid email
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="row fld_row">
                      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 fld_label" id="password">
                        Password <sup>*</sup>
                      </div>
                      <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 fld_input">
                        <b-form-input type="password" v-model.trim="password" :state="passwordState"
                          aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                          aria-describedby="passwordFeedback" >
                        </b-form-input>
                        <b-form-invalid-feedback id="passwordFeedback">
                          Password should be 6 characters
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="row fld_row" style="margin-bottom: 10px;">
                      <div class="col-12 fld_label">
                        <div class="row">
                          <div class="col-8 lnk_sec pt-2">
                            <a href="javascript:void(0);" @click="forgotPassword">Forgot password</a>
                          </div>
                          <div class="col-4 btn_container" style="padding-left: 1.5rem;">
                            <b-button size="lg" @click="login" :disabled="!enableLogin">login</b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row fld_row">
                      <div class="col-12 fld_label">
                        <div class="row">
                          <div class="col-12 lnk_sec pt-2">
                            <a href="javascript:void(0);" @click="switchToLogin('signup')">Sign up if you don't have an account</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>
              </div>
            </template>
            <template v-else-if="isOtherInstitutionAccount">
              <div class="row pg_subhd">
                <div class="col-12">
                  <div class="hd_txt">
                    <span>Login to {{institutionMeta.title}}</span>
                  </div>
                  <div class="row hd_msg">
                    <div class="col-xl-7 col-lg-8 col-md-12 col-sm-12 txt_center" style="margin: auto;" v-html="otherInstitutionMeta.message"></div>
                  </div>
                  <div class="row">
                    <div class="col-xl-7 col-lg-8 col-md-12" style="margin: auto; padding-top: 10px; height: 20px;">
                      <div class="w-100" id="validation-message" style="color: #ff0000; text-align: center;  display: none;" v-html="errorMessage"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div @keydown.enter="login">
                <div class="row crd_container">
                  <b-card class="col-12 crd price_plan_sec price_plan_sec2">
                    <div class="row fld_row">
                      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 fld_label" id="userEmail">
                        Email <sup>*</sup>
                      </div>
                      <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 fld_input">
                        <b-form-input type="email" v-model.email="eMail" :state="eMailState"
                          aria-labelledby="email" placeholder="Email" @input="forceEmailLowerCase($event)"
                          aria-describedby="eMailFeedback">
                        </b-form-input>
                        <b-form-invalid-feedback id="eMailFeedback">
                          This is not a valid email
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="row fld_row">
                      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 fld_label" id="password">
                        Password <sup>*</sup>
                      </div>
                      <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 fld_input">
                        <b-form-input type="password" v-model.trim="password" :state="passwordState"
                          aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                          aria-describedby="passwordFeedback" >
                        </b-form-input>
                        <b-form-invalid-feedback id="passwordFeedback">
                          Password should be 6 characters
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="row fld_row" style="margin-bottom: 10px;">
                      <div class="col-12 fld_label">
                        <div class="row">
                          <div class="col-8 lnk_sec pt-2">
                            <a href="javascript:void(0);" @click="forgotPassword">Forgot password</a>
                          </div>
                          <div class="col-4 btn_container" style="padding-left: 1.5rem;">
                            <b-button size="lg" @click="login" :disabled="!enableLogin">login</b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="row pg_subhd">
                <div class="col-12">
                  <div class="hd_txt prg_title">
                    <span>{{programGuide.title}}</span>
                  </div>
                  <div class="hd_msg">
                      <div v-if="programGuide.learnMoreFlowMessage" v-html="programGuide.learnMoreFlowMessage">
                      </div>
                      <div v-else-if="institutionMeta.learnFlowMessage" v-html="institutionMeta.learnFlowMessage">
                      </div>
                      <div v-else>
                        Thank you for your interest in enrolling in {{programGuide.title}}. Let's start with your contact information.
                      </div>
                  </div>
                </div>
              </div>
              <div class="row crd_container">
                <b-card class="col-12 crd price_plan_sec price_plan_sec2">
                  <div class="row fld_row">
                    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 fld_label" id="firstName">
                      First Name <sup>*</sup>
                    </div>
                    <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 fld_input">
                      <b-form-input type="text" v-model.trim="firstName" :state="firstNameState"
                        aria-labelledby="firstName" placeholder="First Name" @input="$v.firstName.$touch()"
                        aria-describedby="firstNameFeedback">
                      </b-form-input>
                      <b-form-invalid-feedback id="firstNameFeedback">
                        First Name can not left blank
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="row fld_row">
                    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 fld_label" id="lastName">
                      Last Name <sup>*</sup>
                    </div>
                    <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 fld_input">
                      <b-form-input type="text" v-model.trim="lastName" :state="lastNameState"
                        aria-labelledby="lastName" placeholder="Last Name" @input="$v.lastName.$touch()"
                        aria-describedby="lastNameFeedback">
                      </b-form-input>
                      <b-form-invalid-feedback id="lastNameFeedback">
                        Last Name can not left blank
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="row fld_row">
                    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 fld_label" id="userEmail">
                      Email <sup>*</sup>
                    </div>
                    <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 fld_input">
                      <b-form-input type="email" v-model.email="eMail" :state="eMailState"
                        aria-labelledby="email" placeholder="Email" @input="forceEmailLowerCase($event)"
                        aria-describedby="eMailFeedback">
                      </b-form-input>
                      <b-form-invalid-feedback id="eMailFeedback">
                        This is not a valid email
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="row fld_row">
                    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 fld_label" id="password">
                      Password <sup>*</sup>
                    </div>
                    <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 fld_input">
                      <b-form-input type="password" v-model.trim="password" :state="passwordState"
                        aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                        aria-describedby="passwordFeedback">
                      </b-form-input>
                      <b-form-invalid-feedback id="passwordFeedback">
                        Password should be 6 characters
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="row fld_row">
                    <div class="col-12 fld_label">By Clicking on Sign Up, you accept to the <a href="https://site.pragyasystems.com/terms-of-use/" target="_blank">terms of use</a> & <a href="https://site.pragyasystems.com/privacy-policy/" target="_blank">privacy policy</a>.</div>
                  </div>
                  <div class="row fld_row">
                    <div class="col-12 fld_label">
                      <div class="row">
                        <div class="col-7 lnk_sec pt-2">
                          <a href="javascript:void(0);" @click="switchToLogin('login')">Login if you have an account</a>
                        </div>
                        <div class="col-5 btn_container" style="padding-left: 2rem;">
                          <b-button size="lg" @click="createAccount" :disabled="!enableCreateAccount">sign up</b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
            </template>
          </template>
        </template>
        <template v-else>
          <div class="row content-row">
            <div class="col-12">
              <div class="text-center">
                <h4>Link is not valid. Please contact your administrator.</h4>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="institutionMeta">
      <b-modal v-model="showForgotPasswordModal" title="Forgot Password" :header-bg-variant="'warning'" :header-text-variant="'dark'" :footer-bg-variant="'light'" no-close-on-backdrop no-close-on-esc centered>
        <div class="text-center" @keydown.enter="resetPassword">
          <template v-if="resetPasswordMessage">
            <span style="color: Red;">{{resetPasswordMessage}}</span>
          </template>
          <template v-else>
            <div class="float-left mr-3">
              <div class="fld-label">User Email</div>
            </div>
            <div class="ml-5">
              <b-form-input type="email" v-model.email="resetPasswordEmail" :state="resetPasswordEmailState"
                aria-labelledby="reset email" placeholder="Email" @blur.native="$v.resetPasswordEmail.$touch()"
                aria-describedby="resetPasswordEmailFeedback" style="height: 1.5em !important; width: 70%;">
              </b-form-input>
              <b-form-invalid-feedback id="resetPasswordEmailFeedback">
                Please enter a proper email address.
              </b-form-invalid-feedback>
            </div>
          </template>
        </div>
        <div slot="modal-footer" class="w-100">
          <template v-if="resetPasswordMessage">
            <b-button variant="primary" size="sm" class="float-right" @click="showForgotPasswordModal = false">ok</b-button>
          </template>
          <template v-else>
            <b-button variant="primary" size="sm" class="float-right ml-3" @click="resetPassword">get new password</b-button>
            <b-button variant="primary" size="sm" class="float-right" @click="showForgotPasswordModal = false">cancel</b-button>
          </template>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue'
  import _ from 'lodash'
  import { mapActions } from 'vuex'
  import Vuelidate from 'vuelidate'
  import {required, email, minLength} from 'vuelidate/lib/validators'
  Vue.use(Vuelidate)
  import { setItem } from '../../../storage'

  export default {
    name: 'learnMore',
    data: () => {
      return {
        orgId: '',
        eMail: '',
        firstName: '',
        lastName: '',
        password: '',
        cipCode: '',
        code: '',
        type: '',
        programGuide: {},
        verificationCode: '',
        showVerifyEmail: false,
        isExistingAccount: false,
        roles: {role: 'Student'},
        userProfile: {courses: [], areaOfInterest: [], experience: '', bio: ''},
        institutionMeta: null,
        errorMessage: '',
        showForgotPasswordModal: false,
        resetPasswordEmail: '',
        resetPasswordMessage: null,
        otherInstitutionMeta: null,
        isOtherInstitutionAccount: false
      }
    },
    validations: {
      eMail: {
        required,
        email
      },
      firstName: {
        required
      },
      lastName: {
        required
      },
      password: {
        required,
        minLength: minLength(6)
      },
      verificationCode: {
        required
      },
      resetPasswordEmail: {
        required,
        email
      }
    },
    created () {
      this.resetData()
      this.orgId = this.getQueryParamByName('orgId')
      this.cipCode = this.getQueryParamByName('cipCode')
      this.code = this.getQueryParamByName('code')
      this.type = this.getQueryParamByName('type')

     let utm_medium = this.getQueryParamByName('utm_medium')
      localStorage.setItem('utm_medium', utm_medium)
      let utm_source = this.getQueryParamByName('utm_source')
      localStorage.setItem('utm_source', utm_source)
      let utm_campaign = this.getQueryParamByName('utm_campaign')
      localStorage.setItem('utm_campaign', utm_campaign)
      let utm_content = this.getQueryParamByName('utm_content')
      localStorage.setItem('utm_content', utm_content)
      let utm_term = this.getQueryParamByName('utm_term')
      localStorage.setItem('utm_term', utm_term)
    },
    async beforeMount () {
      this.institutionMeta = await this.loadInstitutionMetaInfoForSelfRegistration(this.orgId)
      let root = document.documentElement;
      root.style.setProperty("--TU__BaseTxtClr", this.institutionMeta.backgroundColor); // Other Text Color
      root.style.setProperty("--TU__BtnClrPri", this.institutionMeta.primaryColor); // Button Color
      root.style.setProperty("--TU__BtnTxtClrPri", this.institutionMeta.secondaryColor); // Button Text Color
      root.style.setProperty("--TU__BtnHoverClrPri", this.institutionMeta.buttonHoverColor); //Button Hover Color
      root.style.setProperty("--TU__BtnTxtHoverClrPri", this.institutionMeta.secondaryColor); // Button Text Color
      root.style.setProperty("--TU__BtnClrSec", this.institutionMeta.primaryColor); // Button Color
      root.style.setProperty("--TU__BtnHoverClrSec", this.institutionMeta.buttonHoverColor);  //Button Hover Color
      root.style.setProperty("--TU__LnkClrPri", this.institutionMeta.linkColor); // Link Color
      root.style.setProperty("--TU__LnkHoverClrPri", this.institutionMeta.linkHoverColor); // Link Hover Color
      root.style.setProperty("--TU__LnkClrSec", this.institutionMeta.backgroundColor); // Other Text Color
      root.style.setProperty("--TU__LnkHoverClrSec", this.institutionMeta.backgroundColor); // Other Text Color
      this.programGuide = await this.loadProgramGuideByCodeAndInstitutionId({code: this.code, cipCode: this.cipCode, type: this.type, institutionId: this.orgId})
      this.loadLogDashboardActivity({action: 'learnmore', page: 'learnmore', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institutionMeta.title})

    },
    computed: {
      eMailState () {
        return (this.eMail.length === 0) ? null : !this.$v.eMail.$error
      },
      firstNameState () {
        return (this.firstName.length === 0) ? null : !this.$v.firstName.$error
      },
      lastNameState () {
        return (this.lastName.length === 0) ? null : !this.$v.lastName.$error
      },
      passwordState () {
        return (this.password.length === 0) ? null : !this.$v.password.$error
      },
      verificationCodeState () {
        return (this.verificationCode.length === 0) ? null : !this.$v.verificationCode.$error
      },
      resetPasswordEmailState () {
        return (this.resetPasswordEmail.length === 0) ? null : !this.$v.resetPasswordEmail.$error
      },
      enableCreateAccount () {
        return (this.firstNameState && this.lastNameState && this.eMailState && this.passwordState && this.password.length >= 6)
      },
      enableLogin () {
        return (this.eMailState && this.passwordState && this.password.length >= 6)
      },
      logoUrl () {
        if (this.institutionMeta && this.institutionMeta.logoUrl) {
          return this.institutionMeta.logoUrl
        }
        return null
      }
    },
    methods: {
      ...mapActions([
        'loadInstitutionMetaInfoForSelfRegistration',
        'loadProgramGuideByCodeAndInstitutionId',
        'loadLearnerSelfRegistration',
        'loadVerifySelfRegistration',
        'loadResetPassword',
        'loadUserLogin',
        'loadLogDashboardActivity'
      ]),
      showLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.hide()
        }
      },
      getQueryParamByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&')
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        let results = regex.exec(decodeURIComponent(url))
        if (!results || !results[2]) return ''
        let value = results[2].replace(/\+/g, ' ')
        return value
      },
      forceEmailLowerCase (e) {
        e = e.trim().toLowerCase()
        this.$set(this.$data, 'eMail', e)
        this.$v.eMail.$touch()
      },
      resetData () {
        this.orgId = ''
        this.cipCode = ''
        this.code = ''
        this.type = ''
        this.resetLoginSignupData()
        this.isExistingAccount = false
      },
      createAccount () {
        this.$v.eMail.$touch()
        this.$v.firstName.$touch()
        this.$v.lastName.$touch()
        this.$v.password.$touch()
        if (this.enableCreateAccount) {
          this.showLoader()
          let userObj = {
            eMail: this.eMail,
            firstName: this.firstName,
            lastName: this.lastName,
            password: this.password,
            userProfile: this.userProfile,
            sendSelfRegistrationVerificationEmail: true
          }
          this.loadLearnerSelfRegistration({orgId: this.orgId, user: userObj}).then(res => {
            if (res) {
              if (res.accountExists) {
                this.hideLoader()
                this.$notify({
                  group: 'notify',
                  type: 'error',
                  title: '',
                  text: 'An Account already exists with email "' + this.eMail + '" . Login or use different email.'
                })
              } else {
                this.hideLoader()
                let otherInstitutionAccount = res.otherInstitutionAccount
                if (otherInstitutionAccount) {
                  this.eMail = ''
                  this.password = ''
                  this.otherInstitutionMeta = res
                  this.isOtherInstitutionAccount = otherInstitutionAccount
                } else {
                  this.hideLoader()
                  this.showVerifyEmail = true
                  let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
                  this.loadLogDashboardActivity({action: 'signup', page: 'learnmore', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institutionMeta.title,preUser})

                  this.loadLogDashboardActivity({action: 'verifyEmailSent', page: 'learnmore', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institutionMeta.title,preUser})

                }
              }
            } else {
              this.hideLoader()
              this.$notify({
                group: 'notify',
                type: 'error',
                title: '',
                text: 'Please try again. Note that this email "' + this.eMail + '" might already be taken.'
              })
            }
          })
        }
      },
      async verifyEmail () {
        this.$v.verificationCode.$touch()
        if (this.verificationCodeState) {
          let userObj = {
            eMail: this.eMail,
            institutionId: this.orgId,
            verificationCode: this.verificationCode
          }
          let response = await this.loadVerifySelfRegistration(userObj)
          let status = response.status
          let data = response.data
          if (status === 200) {
            if (data === 'invalid_verification_code') {
              this.$notify({
                group: 'notify',
                type: 'error',
                title: '',
                text: 'Your verification code is incorrect or expired.'
              })
            } else {
              this.$parent.isLearnMore = false
              let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
              this.loadLogDashboardActivity({action: 'eMailVerified', page: 'learnmore', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institutionMeta.title,preUser})

              return this.$router.push({name: 'programGuideMenu', params: {cipCode: this.programGuide.cipCode, programGuideCode: this.programGuide.code, type: this.programGuide.type}})
            }
          }
        }
      },
      resetLoginSignupData () {
        this.eMail = ''
        this.firstName = ''
        this.lastName = ''
        this.password = ''
        this.errorMessage = ''
        this.verificationCode = ''
        this.otherInstitutionMeta = null
      },
      switchToLogin (action) {
        this.resetLoginSignupData()
        if (action === 'login') {
          let path = this.institutionMeta.path
          let ssoUrl = this.institutionMeta.ssoUrl
          if (path && ssoUrl) {
            window.open(window.location.origin + '/sso/' + path, '_self')
          } else {
            this.restoredSessionFromToken()
          }
        } else {
          this.isExistingAccount = false
        }
      },
      login () {
        this.$v.eMail.$touch()
        this.$v.password.$touch()
        if (this.enableLogin) {
          this.showLoader()
          this.errorMessage = ''
          if (this.isOtherInstitutionAccount) {
            let userObj = {
              eMail: this.eMail,
              firstName: this.firstName,
              lastName: this.lastName,
              password: this.password,
              userProfile: this.userProfile,
              loginUsingOtherInstitutionAccount: true,
              sendSelfRegistrationVerificationEmail: false
            }
            this.loadLearnerSelfRegistration({orgId: this.orgId, user: userObj}).then(res => {
              let data = res.data
              let status = res.status
              if (status === 200) {
                this.hideLoader()
                this.$parent.isLearnMore = false
                let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
                this.loadLogDashboardActivity({action: 'signin', page: 'learnmore', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institutionMeta.title,preUser})

                return this.$router.push({name: 'programGuideMenu', params: {cipCode: this.programGuide.cipCode, programGuideCode: this.programGuide.code, type: this.programGuide.type}})
              } else {
                this.hideLoader()
                let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
                this.loadLogDashboardActivity({action: 'signinFail', page: 'learnmore', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institutionMeta.title,preUser})

                switch (status) {
                  case 401:
                    this.errorMessage = data
                    break
                  case 400:
                    this.errorMessage = 'Please enter all required fields'
                    break
                  case 503:
                    this.errorMessage = 'Server temporarily unavailable'
                    break
                  default:
                    this.errorMessage = 'Unexpected error code: ' + status
                    break
                }
              }
              if (this.errorMessage.length > 0) {
                $('#validation-message').fadeIn('fast').delay(3000).fadeOut('slow')
              }
            })
          } else {
            this.loadUserLogin({eMail: this.eMail, password: this.password, institutionId:this.institutionMeta.institutionId}).then(res => {
              let status = res.status
              let userObj = res.data
              if (status === 200) {
                this.hideLoader()
                let role = userObj.roles[0].role
                if (userObj.institutionId !== this.institutionMeta.institutionId) {
                  this.errorMessage = '<b>' + this.eMail + '</b> does not exist in <b>' + this.institutionMeta.title + '</b>. Please contact your administrator.'
                }
                if (role !== this.roles.role) {
                  this.errorMessage = 'You don\'t have a <b>Learner account</b> in <b>' + this.institutionMeta.title + '</b>. Please contact your administrator.'
                }
                if (!this.errorMessage || (this.errorMessage.length === 0)) {
                  this.$parent.isLearnMore = false
                  return this.$router.push({name: 'programGuideMenu', params: {cipCode: this.programGuide.cipCode, programGuideCode: this.programGuide.code, type: this.programGuide.type}})
                }
              } else {
                this.hideLoader()
                switch (status) {
                  case 503:
                    this.errorMessage = 'Server temporarily unavailable'
                    break
                  case 401:
                    this.errorMessage = 'Invalid email or password'
                    break
                  case 400:
                    this.errorMessage = 'Please enter all required fields'
                    break
                  default:
                    this.errorMessage = 'Unexpected error code: ' + status
                    break
                }
              }
              if (this.errorMessage.length > 0) {
                $('#validation-message').fadeIn('fast').delay(3000).fadeOut('slow')
              }
            })
          }
        }
      },
      forgotPassword () {
        this.resetPasswordEmail = ''
        this.resetPasswordMessage = null
        this.showForgotPasswordModal = true
        this.$v.resetPasswordEmail.$touch()
      },
      resetPassword () {
        this.$v.resetPasswordEmail.$touch()
        if (this.resetPasswordEmailState) {
          this.loadResetPassword(this.resetPasswordEmail).then(res => {
            let status = res.status
            switch (status) {
              case 401:
                this.resetPasswordMessage = 'This email "' + this.resetPasswordEmail + '" does not exist.'
                break
              case 500:
                this.resetPasswordMessage = 'Error in service call.'
                break
              default:
                this.resetPasswordMessage = 'Please check your registered email for password reset instructions.'
                break
            }
          })
        }
      },
      isSessionExpired () {
        let token = localStorage.getItem('token')
        if (token) {
          let loginTime = localStorage.getItem('loginTime')
          let currentTime = (new Date()).getTime()
          let currentSessionDuration = (currentTime - loginTime) / 60000
          return (currentSessionDuration > 480)
        }
        return true
      },
      restoredSessionFromToken () {
        if (this.isSessionExpired()) {
          this.isExistingAccount = true
        } else {
          let role = localStorage.getItem('userrole')
          let institutionId = localStorage.getItem('institutionId')
          if ((institutionId === this.institutionMeta.institutionId) && (role === this.roles.role)) {
            this.$parent.isUserLoggedIn = true
            this.$parent.isServiceAvailable = true
            this.$parent.isLearnMore = false
            return this.$router.push({name: 'programGuideMenu', params: {cipCode: this.programGuide.cipCode, programGuideCode: this.programGuide.code, type: this.programGuide.type}})
          } else {
            localStorage.clear()
            this.isExistingAccount = true
          }
        }
      }
    }
  }
</script>

<style scoped>
  .top-bar {
    height: 50px;
    padding-top: 0;
    background: #f5f5f5;
  }
  .content-section {
    float: left;
    width: 100%;
    margin-top: 25px;
    background: #f5f5f5;
    border: 1px solid #e3e3e3;
    padding: 20px;
    border-radius: 0;
  }
  .sec_hd {
    text-align: center;
    font-size: 17px;
    font-weight: 600;
    border-bottom: none;
  }
  .fld_row {
    margin-bottom: 15px;
  }
  .fld_label {
    text-align: left;
    padding-bottom: 5px;
    margin: auto;
    max-width: 450px;
  }
  .create-section .content-section sup {
    color: red;
    font-size: 17px;
    top: -2px;
    left: 2px;
  }
  .popup_head_txt {
    font-size: 1.1rem;
    width: 75%;
    color: #323232;
  }
</style>



// WEBPACK FOOTER //
// src/app/login/components/LearnMore.vue